/*
 * Copyright (c) 2025 NoorWays. All rights reserved.
 * Licensed under the terms specified in the LICENSE.txt file.
 */

import type { AxiosError } from 'axios'
import { logger } from '@/services/logger'

/**
 * Handle HTTP success responses
 * This is a simplified version for the web client
 */
export function handleHttpSuccess(): void {
  // For web client, we can implement simple success handling
  // In a full implementation, this might show toast notifications
  logger.info('HTTP request successful', {}, 'http')
}

/**
 * Handle HTTP error responses
 * This is a simplified version for the web client
 */
export function handleHttpError(error: AxiosError): void {
  // For web client, we can implement simple error handling
  // In a full implementation, this might show toast notifications or error dialogs
  
  logger.error('HTTP request failed:', error, {
    status: error.response?.status,
    statusText: error.response?.statusText,
    url: error.config?.url
  }, 'http')

  // You could extend this to show user-friendly error messages
  // based on the error type and status code
  if (error.response?.status === 401) {
    logger.warn('Authentication required', { status: 401 }, 'http')
  } else if (error.response?.status === 403) {
    logger.warn('Access forbidden', { status: 403 }, 'http')
  } else if (error.response?.status === 404) {
    logger.warn('Resource not found', { status: 404 }, 'http')
  } else if (error.response?.status && error.response.status >= 500) {
    logger.error('Server error', undefined, { status: error.response.status }, 'http')
  }
}
